export default __webpack_public_path__ + "static/desktop_KV10-8d2443f891f8e0981de2ad40df68611c.mp4";